import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom'

import './index.css'

import { App } from './components/App'
import { AppErrorBoundary } from './components/AppErrorBoundary'

import { reportWebVitals } from './reportWebVitals'

import { ErrorApiLogic } from './store/logic/errorApiLogic'

import { initYandexMetrika } from './common/yandexMetrika'
import { checkTranspilerForClassProperties } from './common/tsUtils'
import { appConfig, suppressMuiReactWarnings } from './common/devUtils'

if (!checkTranspilerForClassProperties()) {
  throw new Error('Transpiler is not configured correctly for class properties')
}

if (!appConfig.isProduction) {
  suppressMuiReactWarnings()
}

// NOTE: Strict mode double-invokes effects, which can be painful for debugging
ReactDOM.render(
  <StrictMode>
    <AppErrorBoundary createErrorApiLogic={() => new ErrorApiLogic()}>
      <App/>
    </AppErrorBoundary>
  </StrictMode>,
  document.getElementById('root'))

if (appConfig.isProduction) {
  initYandexMetrika()
}

reportWebVitals()